import React, { Component } from 'react';

/* 개발담당:양유빈
 * 화면기능:개인정보 취급방법
 * 세부설명:
*/

export class Privacypolicy extends Component {
    static displayName = Privacypolicy.name;

    constructor(props) {
        super(props);
        this.state = {
        };
    }
    //초기화
    componentDidMount() {
    }
    componentWillUnmount() {
    } 

    render() {
        return (
            <div className="container_box p_margin c_padding">
                <p className="text_type1">개인정보 처리방침</p><br />
                <p className="text_type5">주식회사 큰삼촌컴퍼니(이하 "회사"라 함)는 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보 보호법 등에 따라 이용자의 개인정보 및 권익을 보호하고 이와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.
                    회사는 개인정보 처리방침을 개정할 수 있으며, 개정된 개인정보 처리방침에 대해서는 공지사항 또는 이용자에 대한 이메일 등을 통한 개별공지를 통하여 공지하도록 하겠습니다.</p><br />
                <p className="text_type4">제1조(개인정보의 수집·이용 목적, 수집·이용하는 개인정보 항목 및 보유기간)</p><br />
                <p className="text_type5">① 회사는 본 개인정보 처리방침에서 정하는 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 제4항의 목적 이외의 용도로는 이용되지 않으며, 이용목적이 변경되는 경우에는 정보통신망 이용촉진 및 정보보호 등에 관한 법률 제22조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.<br />
                    ② 회사는 법령에 따른 개인정보 보유·이용기간 또는 이용자로부터 개인정보를 수집시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.<br />
                    ③ 개인정보를 수집하는 방법은 다음 각 호와 같습니다.<br />
                    &nbsp; &nbsp;1. 이용자가 서비스 이용 과정에서 직접 입력<br />
                    &nbsp; &nbsp;2. 서비스 실행시 생성정보 수집 툴을 통한 자동 수집<br />
                    ④ 각각의 수집·이용하는 개인정보 항목 및 보유기간은 다음과 같습니다.<br /></p>

                <div className="p_box_wrap">
                    <table className="privacy_tablebox">
                        <colgroup>
                            <col width="40%;" />
                            <col width="20%;" />
                            <col width="40%;" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>수집 이용 목적</th>
                                <th>수집 이용하는 개인정보 항목</th>
                                <th>보유기간</th>
                            </tr>
                            <tr>
                                <td>회원가입 및 회원관리
                                    회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 제한적 본인확인제 시행에 따른 본인확인, 서비스 부정이용 방지, 각종 고지·통지, 분쟁 조정을 위한 기록 보존 등</td>
                                <td>아이디, 비밀번호, 이메일 주소, 휴대전화번호, 회사명</td>
                                <td>1. 원칙: 회원 탈퇴시까지<br />
                                    2. 신용정보의 수집/처리 및 이용 등에 관한 기록: 3년 <br />(신용정보의 이용 및 보호에 관한 법률)<br />
                                    3. 소비자 불만 또는 분쟁처리에 관한 기록: 3년 <br />(전자상거래 등에서의 소비자 보호에 관한 법률)</td>
                            </tr>
                            <tr>
                                <td>
                                    민원사무 처리
                                    민원인의 신원 확인, 민원사항 확인 등</td>
                                <td>
                                    이메일 주소, 휴대전화번호
                                </td>
                                <td>
                                    소비자 불만 또는 분쟁처리에 관한 기록: 3년 <br />(전자상거래 등에서의 소비자 보호에 관한 법률)</td>
                            </tr>
                            <tr>
                                <td>
                                    서비스 제공
                                    클로디서비스, 화물 연계 서비스, 맞춤 서비스 제공, 본인인증</td>
                                <td>
                                    아이디, 비밀번호, 이메일 주소,<br /> 휴대전화번호, 회사명
                                </td>
                                <td>
                                    1. 원칙: 재화, 서비스 공급완료, 정산 완료시까지 또는 회원 탈퇴 시까지<br />
                                    2. 계약 또는 청약철회: 5년 <br />(전자상거래 등에서의 소비자 보호에 관한 법률)<br />
                                    3. 소비자의 불만 또는 분쟁처리에 관한 기록: 5년 <br />(전자상거래 등에서의 소비자 보호에 관한 법률)
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    서비스 이용과정에서 자동으로 생성되어 수집되는 항목</td>
                                <td>
                                    서비스 이용 기록, 접속 로그,<br /> 쿠키, 접속 IP 정보, 결제기록
                                </td>
                                <td>
                                    통신비밀보호법 시행령 제41조에 따른 통신사실확인자료: 3개월 <br />(통신비밀보호법)
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <p className="text_type5">⑤ 이용자는 회사가 수집하는 개인정보의 항목 및 수집 방법에 동의를 거부할 수 있으며, 거부 시 이용자에게 제공되는 서비스 이용의 일부가 제한될 수 있습니다.</p><br />

                <p className="text_type4">제2조(개인정보 처리의 위탁)</p><br />
                <p className="text_type5">① 회사는 원활하고 향상된 서비스를 위하여 개인정보 처리를 타인에게 위탁할 수 있습니다. 이 경우 회사는 정보통신망 이용촉진 및 정보보호 등에 관한 법률 제25조에 따라 사전에 다음 각 호의 사항 모두를 이용자에게 미리 알리고 동의를 받습니다. 다음 각 호의 어느 하나의 사항이 변경되는 경우에도 같습니다. 위탁받는 업체, 위탁하는 업무의 내용이 변경될 경우, 웹사이트의 공지사항을 통하여 알려드리겠습니다.<br />
                    &nbsp; &nbsp;1. 개인정보 처리 위탁을 받는 자<br />
                    &nbsp; &nbsp;2. 개인정보 처리 위탁을 하는 업무의 내용<br />
                    ② 회사는 정보통신서비스의 제공에 관한 계약을 이행하고 이용자의 편의 증진 등을 위하여 필요한 경우 개인정보 처리방침에 따라 제1항 각 호의 사항을 공개하는 등으로 이용자에게 알린 경우 고지절차와 동의절차를 거치지 아니하고 개인정보 처리를 타인에게 위탁할 수 있습니다.<br />
                    ③ 회사는 개인정보의 처리와 관련하여 아래와 같이 업무를 위탁하고 있으며, 관계 법령에 따라 위탁 계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 조치를 하고 있습니다. 회사는 위탁 계약 시 수탁자의 개인정보 보호조치 능력을 고려하고, 개인정보의 안전한 관리 및 파기 등 수탁자의 의무 이행 여부를 주기적으로 확인합니다. 또한 위탁 처리하는 정보는 원활한 서비스를 제공하기 위하여 필요한 최소한의 정보에 국한됩니다.</p><br />
                <p className="text_type4">제3조(이용자의 권리, 의무 및 그 행사방법)</p><br />

                <p className="text_type5">① 이용자(만 14세 미만인 경우에는 법정대리인을 말함)는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.<br />
                    &nbsp; &nbsp;1. 개인정보 열람 요구<br />
                    &nbsp; &nbsp;2. 오류 등이 있을 경우 정정 요구<br />
                    &nbsp; &nbsp;3. 삭제 요구<br />
                    &nbsp; &nbsp;4. 처리정지 요구<br />
                    &nbsp; &nbsp;5. 개인정보처리에 대한 동의에 대한 철회<br />
                    ② 제1항에 따른 권리 행사는 회사에 대해 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 회사는 이에 대해 지체 없이 조치하겠습니다.<br />
                    ③ 이용자가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.<br />
                    ④ 제1항에 따른 권리 행사는 이용자의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보보호법 시행규칙 별지 제11호 서식을 참고하여 위임장을 제출하셔야 합니다.</p><br />

                <p className="text_type4">제4조(개인정보 파기절차 및 파기방법)</p><br />

                <p className="text_type5">회사는 원칙적으로 개인정보 수집·이용 목적이 달성되거나 보유기간이 종료된 경우 등 파기사유가 발생하는 경우, 이용자의 개인정보를 지체 없이 파기합니다. 다만, 관계 법령에 따라 개인정보를 보존하여야 하는 경우에는 해당 기간 경과 후 지체 없이 재생 불가능한 방법으로 파기하는데, 이때 별도 저장 관리되는 개인정보는 법령에 정한 경우를 제외하고 다른 용도로 이용되지 않습니다. 구체적인 파기 절차, 기한 및 방법은 다음과 같습니다.</p><br />

                <div className="p_box_wrap">
                    <table className="privacy_tablebox">
                        <colgroup>
                            <col width="33.33%;" />
                            <col width="33.33%;" />
                            <col width="33.33%;" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>파기절차</th>
                                <th>파기기한</th>
                                <th>파기방법</th>
                            </tr>
                            <tr>
                                <td>
                                    이용자가 입력한 개인정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이는 별도 서류함) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB 또는 별도 서류함으로 옮겨진 개인정보는 법령에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.
                                </td>
                                <td>
                                    이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 보유기간의 종료일로부터 5일 이내에, 개인정보의 수집·이용 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 개인정보의 수집·이용이 불필요한 것으로 인정되는 날로부터 5일 이내에 파기합니다.
                                </td>
                                <td>
                                    전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적인 방법을 사용하여 파기하고, 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p className="text_type4">제5조(개인정보 파기절차 및 파기방법)</p><br />

                <p className="text_type5">회사는 정보통신망 이용촉진 및 정보보호 등에 관한 법률 제28조에 따라 다음 각 호와 같이 개인정보의 안전성 확보에 필요한 기술적, 관리적, 물리적 조치를 취하고 있습니다.<br />
                    1. 정기적인 자체 감사 실시<br />
                    2. 내부관리계획의 수립 및 시행<br />
                    3. 보안프로그램의 설치 등 해킹 등에 대비한 기술적 대책 수립 및 시행<br />
                    4. 개인정보의 암호화기술 등을 이용한 보안조치 시행<br />
                    5. 접속기록의 보관 및 접속기록 위·변조 방지를 위한 조치 시행<br />
                    6. 개인정보에 대한 불법적인 접근을 차단하기 위한 침입차단시스템 등 접근 통제장치의 설치·운영</p><br />


                <p className="text_type4">제6조(개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항)</p><br />

                <p className="text_type5">① 회사는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다.<br />
                    ② 쿠키는 회사의 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며, 이용자들의 컴퓨터, 태블릿, 스마트폰 또는 기타 기기의 하드디스크에 저장됩니다.<br />
                    &nbsp; &nbsp;1. 쿠키의 사용 목적 : 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.<br />
                                            &nbsp; &nbsp;2. 쿠키의 설치•운영 및 거부 : 웹 브라우저 상단의 도구 > 인터넷 옵션 > 개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수 있습니다.<br />
                    &nbsp; &nbsp;3. 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.</p><br />

                <p className="text_type4">제7조(개인정보보호 책임자 및 연락처)</p><br />

                <p className="text_type5">① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 이용자의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보보호 책임자를 지정하고 있습니다. 회사 서비스를 이용하시면서 발생한 모든 개인정보보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보보호 책임자 및 담당부서에 문의하실 수 있습니다.<br />
                    &nbsp; &nbsp;▶ 개인정보보호 책임자<br />
                    &nbsp; &nbsp;&nbsp; &nbsp;- 성 명 : 이항영<br />
                    &nbsp; &nbsp;&nbsp; &nbsp;- 소 속 : 경영지원팀<br />
                    &nbsp; &nbsp;&nbsp; &nbsp;- 직 책 : 대표<br />
                    &nbsp; &nbsp;&nbsp; &nbsp;- 연락처 : ceo@big3.kr<br />

                    ② 기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.<br />
                    &nbsp; &nbsp;▶ 개인정보 침해신고센터 (한국인터넷진흥원 운영)<br />
                    &nbsp; &nbsp;&nbsp; &nbsp;- 소관업무 : 개인정보 침해사실 신고, 상담 신청<br />
                    &nbsp; &nbsp;&nbsp; &nbsp;- 홈페이지 : privacy.kisa.or.kr<br />
                    &nbsp; &nbsp;&nbsp; &nbsp;- 전화 : (국번없이) 118<br />
                    &nbsp; &nbsp;&nbsp; &nbsp;- 주소 : (58342) 전남 나주시 진흥길 9(빛가람동) 한국인터넷진흥원 개인정보침해 신고센터<br />
                    &nbsp; &nbsp;▶ 개인정보 분쟁조정위원회<br />
                    &nbsp; &nbsp;&nbsp; &nbsp;- 소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)<br />
                    &nbsp; &nbsp;&nbsp; &nbsp;- 홈페이지 : www.kopico.go.kr<br />
                    &nbsp; &nbsp;&nbsp; &nbsp;- 전화 : (국번없이) 1833-6972<br />
                    &nbsp; &nbsp;&nbsp; &nbsp;- 홈페이지 : cyberbureau.police.go.kr</p><br />

                <p className="text_type4">제8조(개인정보 처리방침의 변경)</p><br />

                <p className="text_type5">① 본 개인정보 처리방침은 회사의 필요에 의하여 변경될 수 있고, 내용의 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일 전부터 공지사항을 통해 사전 고지할 것입니다. 다만, 개인정보의 수집·이용 목적, 제3자 제공 대상 등 중요한 사항이 추가, 삭제 및 수정되는 경우에는 14일 전에 사전 고지하고, 14일이 경과된 후에 시행됩니다.<br />
                    ② 회사는 개인정보의 수집 및 이용, 제3자 제공 등 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 관련 법령에 따라 이용자의 별도 동의가 필요한 사항과 관련된 내용이 추가, 변경되는 경우에는 관련 법령에 따라 이용자로부터 별도의 동의를 받습니다.<br />
                    ③ 회사는 개인정보 처리방침에 다음과 같이 버전번호, 변경공고일자 및 그 시행일자 등을 부여하여 개정여부를 쉽게 알 수 있도록 하고 있습니다.<br />
                    ④ 본 개인정보 처리방침의 버전번호, 변경공고일자 및 시행일자는 다음과 같습니다.<br />
                    &nbsp; &nbsp;&nbsp; &nbsp;* 공고일자: 2022년 04월 10일<br />
                    &nbsp; &nbsp;&nbsp; &nbsp;* 시행일자: 2022년 04월 10일</p><br />
            </div>
        );
    }
}
